import cta from '~/components/atoms/a-ctas/a-cta-v2.data'

export default {
  eyebrow: null,
  heading: 'We shape digital products with unique DNA.',
  href: {
    url: '/articles',
    cached_url: '/articles',
  },
  image: {
    alt: 'Image for the entry.',
    filename:
      '//a.storyblok.com/f/46530/2501x1668/d5dafedba0/gabriel-benois-qnwpjzewewa-unsplash.jpg',
  },
  pattern: '//a.storyblok.com/f/46530/236x236/c7724d4841/pattern-1.png',
  copy: null,
  cta: [
    {
      ...cta,
      copy: 'Read Article',
      href: {
        url: '/articles',
        cached_url: '/articles',
      },
      type: 'secondary',
    },
  ],
  component: 'm-card-feature',
}
